import { ComboboxInput } from '@headlessui/react';

export const SearchInput = ({
  placeholder,
  query,
  setQuery,
  dataTestId,
}: {
  placeholder: string;
  query: string;
  setQuery: (value: string) => void;
  dataTestId?: string;
}) => {
  return (
    <div
      className="relative z-10 w-full"
      {...(dataTestId && dataTestId.trim() !== ''
        ? { 'data-testid': dataTestId }
        : {})}
    >
      <ComboboxInput
        type={'search'}
        placeholder={placeholder}
        className="top-0 w-full border-0 border-b border-gray-300 dark:border-gray-600 py-2 pl-3 text-sm text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 focus:border-gray-300 dark:focus:border-gray-600 focus:ring-0"
        autoFocus
        onChange={(event) => setQuery(event.target.value)}
        displayValue={() => query}
      />
    </div>
  );
};
